// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { CREATE_ASSETS } from "../../graphql/mutations/assets/assets.mutations";

const useCreateManyAssets = () => {
  const [createAssetsMutation, { loading, error, data }] =
    useMutation(CREATE_ASSETS);

  const createManyAssets = async (assets) => {
    try {
      await createAssetsMutation(assets);
      return data.createAssets;
    } catch (error) {
      console.error(`Error creating assets: ${error?.message}`);
      alert(`Error creating assets: ${error?.message}`);
    }
  };

  return { createManyAssets, loading, error };
};

export default useCreateManyAssets;
